"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require(".");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var transformDataToProps = function (data) {
  if (data === void 0) {
    data = {};
  }

  return Object.keys(data).reduce(function (accumulator, key) {
    var _extends2;

    var value = data[key];
    var prop = (0, _.transformValueToProp)(value);
    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = prop, _extends2));
  }, {});
};

var _default = transformDataToProps;
exports.default = _default;